import { signupFormOpts, loginFormOpts } from './form-options'
import { withForm } from '@/lib/form'
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'

export const SignupForm = withForm({
  ...signupFormOpts,
  props: {
    title: '',
    description: '',
    submitLabel: '',
  },
  render: ({ form, title, description, submitLabel }) => {
    return (
      <form.AppForm>
        <Card>
          <CardHeader>
            <CardTitle>{title}</CardTitle>
            <CardDescription>{description}</CardDescription>
          </CardHeader>
          <CardContent className="flex flex-col gap-4">
            <form.AppField
              name="username"
              children={(field) => (
                <field.TextField
                  label="Username"
                  htmlFor="username"
                  type="text"
                  autoComplete="off"
                  placeholder="johnny_appleseed"
                  data-1p-ignore
                  data-lpignore="true"
                />
              )}
            />
            <form.AppField
              name="email"
              children={(field) => (
                <field.TextField
                  label="Email"
                  htmlFor="email"
                  type="email"
                  autoComplete="email"
                  placeholder="you@example.com"
                />
              )}
            />
            <form.AppField
              name="password"
              children={(field) => (
                <field.TextField
                  label="Password"
                  htmlFor="password"
                  type="password"
                  autoComplete="new-password"
                  placeholder="********"
                />
              )}
            />
          </CardContent>
          <CardFooter>
            <form.SubmitButton label={submitLabel} />
          </CardFooter>
        </Card>
      </form.AppForm>
    )
  },
})

export const LoginForm = withForm({
  ...loginFormOpts,
  props: {
    title: '',
    description: '',
    submitLabel: '',
  },
  render: ({ form, title, description, submitLabel }) => {
    return (
      <form.AppForm>
        <Card>
          <CardHeader>
            <CardTitle>{title}</CardTitle>
            <CardDescription>{description}</CardDescription>
          </CardHeader>
          <CardContent className="flex flex-col gap-4">
            <form.AppField
              name="email"
              children={(field) => (
                <field.TextField
                  label="Email"
                  htmlFor="email"
                  type="email"
                  autoComplete="email"
                  placeholder="you@example.com"
                />
              )}
            />
            <form.AppField
              name="password"
              children={(field) => (
                <field.TextField
                  label="Password"
                  htmlFor="password"
                  type="password"
                  autoComplete="current-password"
                  placeholder="********"
                />
              )}
            />
          </CardContent>
          <CardFooter>
            <form.SubmitButton label={submitLabel} />
          </CardFooter>
        </Card>
      </form.AppForm>
    )
  },
})
